import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-add_c56ef1282c14e50ab89319b50d01f378",
  "use": "ic-add_c56ef1282c14e50ab89319b50d01f378-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"ic-add_c56ef1282c14e50ab89319b50d01f378\">\n    <path fill=\"#000\" d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id